import styled, { css } from "styled-components";
import { select } from "@hubper/theme";

export const phBase = css`
  color: ${select.color(["grey", 3])};
`;

export const inputPlaceholderStyle = css`
  ::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    ${phBase}
  }
  ::-moz-placeholder {
    /* Firefox 19+ */
    ${phBase}
  }
  :-ms-input-placeholder {
    /* IE 10+ */
    ${phBase}
  }
  :-moz-placeholder {
    /* Firefox 18- */
    ${phBase}
  }
`;

export const inputStyle = css<{ isOpen: boolean }>`
  transition: 0.15s;
  background-color: ${select.color(["grey", 0])};
  box-shadow: 0;
  border: 1px solid transparent;
  height: 100%;
  width: 100%;
  border-radius: 3px;
  padding: 0px 12px;
  box-sizing: border-box;
  outline: 0;
  font-family: inherit;
  font-size: ${select.fontSize(-1)};
`;

const dropDownFocusStyle = css<{ isOpen: boolean }>`
  border-bottom: 1px solid ${p => select.color(["grey", p.isOpen ? 1 : 4], p)};
  border-bottom-left-radius: ${p => (p.isOpen ? 0 : 3)}px;
  border-bottom-right-radius: ${p => (p.isOpen ? 0 : 3)}px;
`;

export const focusStyle = css<{ isOpen: boolean; isDropDown: boolean }>`
  border: 1px solid ${select.color(["grey", 4])};
  background-color: white;

  ${p => p.isDropDown && dropDownFocusStyle}
`;

const Input = styled.input<{ isOpen: boolean; isDropDown: boolean }>`
  ${inputStyle}

  ${inputPlaceholderStyle}

  &:focus {
    ${focusStyle}
  }

  &:hover:not(:focus) {
    background-color: hsl(0, 0%, 95%);
  }
`;

export default Input;
